// ─── src/data/featuredVenues.js ───────────────────────────────────────────────
// Global featured venues for the homepage slider & hero.
// Schema matches FeaturedSlider expectations: id, name, region, city, country,
// capacity, rating, reviews, tag, desc, imgs
import { hydrateScores } from "../engine/index.js";

export const FEATURED_VENUES = [
  {
    id: 1,
    name: "Villa Rosanova",
    city: "San Casciano",
    region: "Tuscany",
    country: "Italy",
    capacity: 200,
    rating: 4.9,
    reviews: 312,
    tag: "Estate of the Month",
    desc: "An eighteenth-century Tuscan estate set within 120 acres of rolling countryside, offering ceremony spaces from frescoed salons to olive-grove terraces.",
    imgs: [
      "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1920&q=80",
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=1920&q=80",
    ],
    link: "venue",
    online: true,
    verified: true, lwdScore: 94,
    featured: true,
    styles: ["Romantic", "Rustic Luxe"],
    priceFrom: "£18,000",
    includes: ["Exclusive Use", "Accommodation", "Outdoor Ceremony", "Private Chef"],
    lat: 43.6567,
    lng: 11.1833,
  },
  {
    id: 2,
    name: "Château de Lumière",
    city: "Gordes",
    region: "Provence",
    country: "France",
    capacity: 180,
    rating: 5.0,
    reviews: 276,
    tag: "Luxury Pick",
    desc: "A seventeenth-century château surrounded by lavender fields, offering exclusive three-night hire, Michelin-starred catering and a private vineyard.",
    imgs: [
      "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=1920&q=80",
      "https://images.unsplash.com/photo-1505236858219-8359eb29e329?auto=format&fit=crop&w=1920&q=80",
    ],
    link: null,
    online: true,
    verified: true, lwdScore: 96,
    featured: true,
    styles: ["Romantic", "Rustic Luxe"],
    priceFrom: "£22,000",
    includes: ["Exclusive Use", "Accommodation", "Vineyard", "Spa & Wellness"],
    lat: 43.9114,
    lng: 5.1982,
  },
  {
    id: 3,
    name: "The Grand Pavilion",
    city: "Mayfair",
    region: "London",
    country: "UK",
    capacity: 320,
    rating: 4.9,
    reviews: 312,
    tag: "Top Rated",
    desc: "An iconic Victorian ballroom draped in crystal chandeliers and candlelight, with 60 guest bedrooms and award-winning in-house catering.",
    imgs: [
      "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1920&q=80",
      "https://images.unsplash.com/photo-1544078751-58fee2d8a03b?auto=format&fit=crop&w=1920&q=80",
    ],
    link: null,
    online: false,
    verified: true, lwdScore: 92,
    featured: false,
    styles: ["Glamorous", "Black Tie"],
    priceFrom: "£28,000",
    includes: ["Accommodation", "In-house Catering", "Ballroom", "Private Garden"],
    lat: 51.5074,
    lng: -0.1478,
  },
  {
    id: 4,
    name: "Villa d'Este",
    city: "Cernobbio",
    region: "Lake Como",
    country: "Italy",
    capacity: 150,
    rating: 5.0,
    reviews: 189,
    tag: "Editor's Choice",
    desc: "A Renaissance villa overlooking the sapphire waters of Lake Como, one of the most romantic wedding settings in the world.",
    imgs: [
      "https://images.unsplash.com/photo-1571896349842-33c89424de2d?auto=format&fit=crop&w=1920&q=80",
      "https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=1920&q=80",
    ],
    link: null,
    online: true,
    verified: true, lwdScore: 97,
    featured: true,
    styles: ["Classic", "Luxury"],
    priceFrom: "£35,000",
    includes: ["Waterfront", "Accommodation", "Exclusive Use", "Spa & Wellness"],
    lat: 45.8469,
    lng: 9.0864,
  },
  {
    id: 5,
    name: "Château Margaux Estate",
    city: "Margaux",
    region: "Bordeaux",
    country: "France",
    capacity: 200,
    rating: 4.8,
    reviews: 154,
    tag: "Wine Country",
    desc: "Exchange vows among centuries-old vineyards and golden stone architecture in the heart of Bordeaux wine country.",
    imgs: [
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=1920&q=80",
      "https://images.unsplash.com/photo-1475503572774-15a45e5d60b9?auto=format&fit=crop&w=1920&q=80",
    ],
    link: null,
    online: false,
    verified: true, lwdScore: 85,
    featured: false,
    styles: ["Rustic Luxe", "Destination"],
    priceFrom: "£16,000",
    includes: ["Vineyard", "Outdoor Ceremony", "Accommodation", "Private Chef"],
    lat: 45.0433,
    lng: -0.6769,
  },
  {
    id: 6,
    name: "Amalfi Cliffside Estate",
    city: "Ravello",
    region: "Amalfi Coast",
    country: "Italy",
    capacity: 80,
    rating: 4.9,
    reviews: 118,
    tag: "Cliffside Favourite",
    desc: "Perched above the Tyrrhenian Sea with panoramic views across the coast, intimate, spectacular and forever unforgettable.",
    imgs: [
      "https://images.unsplash.com/photo-1544078751-58fee2d8a03b?auto=format&fit=crop&w=1920&q=80",
      "https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?auto=format&fit=crop&w=1920&q=80",
    ],
    link: null,
    online: true,
    verified: true, lwdScore: 90,
    featured: false,
    styles: ["Intimate", "Destination"],
    priceFrom: "£12,000",
    includes: ["Waterfront", "Outdoor Ceremony", "Mountain Views", "Private Chef"],
    lat: 40.6491,
    lng: 14.6117,
  },
  {
    id: 7,
    name: "Gleneagles Estate",
    city: "Auchterarder",
    region: "Perthshire",
    country: "Scotland",
    capacity: 250,
    rating: 4.8,
    reviews: 167,
    tag: "Highland Romance",
    desc: "A legendary Scottish estate with rolling glens, world-class hospitality and ceremony spaces from grand halls to loch-side gardens.",
    imgs: [
      "https://images.unsplash.com/photo-1549417229-7686ac5595fd?auto=format&fit=crop&w=1920&q=80",
      "https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=1920&q=80",
    ],
    link: null,
    online: false,
    verified: true, lwdScore: 84,
    featured: false,
    styles: ["Country", "Traditional"],
    priceFrom: "£22,000",
    includes: ["Exclusive Use", "Accommodation", "Mountain Views", "Spa & Wellness"],
    lat: 56.2939,
    lng: -3.7128,
  },
  {
    id: 8,
    name: "Santorini Caldera House",
    city: "Oia",
    region: "Santorini",
    country: "Greece",
    capacity: 60,
    rating: 5.0,
    reviews: 203,
    tag: "Island Escape",
    desc: "Whitewashed terraces and infinite caldera views for an unforgettable celebration on one of the world's most iconic islands.",
    imgs: [
      "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1920&q=80",
    ],
    link: null,
    online: true,
    verified: true, lwdScore: 93,
    featured: true,
    styles: ["Intimate", "Bohemian"],
    priceFrom: "£14,000",
    includes: ["Waterfront", "Outdoor Ceremony", "Exclusive Use", "Mountain Views"],
    lat: 36.4618,
    lng: 25.3753,
  },
  {
    id: 9,
    name: "Palazzo Vendramin",
    city: "Venice",
    region: "Veneto",
    country: "Italy",
    capacity: 120,
    rating: 5.0,
    reviews: 145,
    tag: "Most Romantic",
    desc: "A sixteenth-century palazzo on Venice's Grand Canal, arrive by gondola, celebrate in frescoed halls, utterly unmatched.",
    imgs: [
      "https://images.unsplash.com/photo-1523438885200-e635ba2c371e?auto=format&fit=crop&w=1920&q=80",
      "https://images.unsplash.com/photo-1544078751-58fee2d8a03b?auto=format&fit=crop&w=1920&q=80",
    ],
    link: null,
    online: true,
    verified: true, lwdScore: 97,
    featured: true,
    styles: ["Glamorous", "Romantic"],
    priceFrom: "£40,000",
    includes: ["Waterfront", "Exclusive Use", "Historic", "Accommodation"],
    lat: 45.4408,
    lng: 12.3155,
  },
  {
    id: 10,
    name: "Domaine de Châteauvieux",
    city: "Satigny",
    region: "Geneva",
    country: "Switzerland",
    capacity: 100,
    rating: 4.9,
    reviews: 132,
    tag: "Alpine Luxury",
    desc: "A Michelin-starred domaine with Jura mountain panoramas and private vineyards, culinary excellence meets alpine grandeur.",
    imgs: [
      "https://images.unsplash.com/photo-1520854221256-17451cc331bf?auto=format&fit=crop&w=1920&q=80",
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=1920&q=80",
    ],
    link: null,
    online: false,
    verified: true, lwdScore: 88,
    featured: false,
    styles: ["Luxury", "Minimalist"],
    priceFrom: "£30,000",
    includes: ["Vineyard", "Mountain Views", "Private Chef", "Accommodation"],
    lat: 46.2133,
    lng: 6.0628,
  },
];

// ── Hydrate curated index scores ─────────────────────────────────────────────
hydrateScores(FEATURED_VENUES);
